import styled from 'styled-components'

import { helpers } from 'styles'

export const Container = styled.li`
	font-family: ${helpers.font.family.header};
	margin: 0;
	padding: 0 0 0 16px;
`
